export const c = (amount: number | string | null, currency: string): string => {
  if (amount || amount === 0)
    return amount.toLocaleString() + ' ' + currency;
  return '';
}
